
import Control from "./control";
import Process from "./process/process";
import Risk from "./risk";

export class ProcessingActivityContext {
	controls: Control[];

  processes: Process[];

	risks: Risk[];

  constructor() {
		this.controls = [];
		this.risks = [];
    this.processes = [];
  }
}
